import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface LayoutContextValue {
  playbackFooterHeight: number;
  setPlaybackFooterHeight: (height: number) => void;
}

const LayoutContext = createContext<LayoutContextValue | null>(null);

export function useLayout() {
  const ctx = useContext(LayoutContext);
  if (!ctx) throw new Error('useLayout must be used within LayoutProvider');
  return ctx;
}

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [playbackFooterHeight, setHeight] = useState(0);

  const setPlaybackFooterHeight = useCallback((h: number) => setHeight(h), []);

  return (
    <LayoutContext.Provider value={{ playbackFooterHeight, setPlaybackFooterHeight }}>
      {children}
    </LayoutContext.Provider>
  );
}
